export default function SmartTagCastAPI(smartTagVO) {

    let tag = smartTagVO;

    let CastToLocalAdapter = tag.API;

    let castUIDeferred = $.Deferred();
    let castUIPromise = castUIDeferred.promise();

    function onCastUIReady(callback) {
        castUIPromise.done(function() {
            callback();
        });

        return castUIPromise;
    }

    this.ready = function () {
        castUIDeferred.resolve();
    };

    this.initialize = ( sessionId, castName, duration, ads ) => {
        return onCastUIReady(function () {
            try {
                CastToLocalAdapter.CAST.initialize({
                    sessionId: sessionId,
                    castName: castName,
                    duration: duration,
                    ads: ads
                });
            } catch (e) {
                console.debug('CBS site: Error calling CAN.PlayerTag.API.castInitialize', e);
            }
        });
    };

    this.enable = () => {
        CastToLocalAdapter.CAST.enable();
    }
    this.disable = () => {
        CastToLocalAdapter.CAST.disable();
    }

    this.connect = () => {
        CastToLocalAdapter.CAST.sessionRequestSuccess();
    }

    this.getCurrentTime = () => {
        if(CastToLocalAdapter.VIDEO && CastToLocalAdapter.VIDEO.getCurrentTime() && !isNaN(CastToLocalAdapter.VIDEO.getCurrentTime().content)){
            return CastToLocalAdapter.VIDEO.getCurrentTime().content;
        }
        return false;
    }

    this.getGlobalResumeTime = () => {
        if(tag && tag.params && tag.params.CONTENT){
            return tag.params.CONTENT.globalResumeTime;
        }
        return 0;
    };

    this.start = () => {
        CastToLocalAdapter.CAST.start();
    }

    this.end = ( position ) => {
        CastToLocalAdapter.CAST.end( { position: position } );
    }

    this.adBreaks = ( ads, duration ) => {
        CastToLocalAdapter.CAST.adBreaks( { ads: ads, duration: duration } );
    };
    this.adBreakStart = () => {
        CastToLocalAdapter.CAST.adBreakStart()
    };
    this.adBreakEnd = () => {
        CastToLocalAdapter.CAST.adBreakEnd()
    };
    this.playbackProgress = ( position, duration ) => {
        CastToLocalAdapter.CAST.playbackProgress({position: position, duration: duration } );
    };

    this.contentStart = () => {
        CastToLocalAdapter.CAST.contentStart();
    };
    this.contentEnd = () => {
        CastToLocalAdapter.CAST.contentEnd();
    };
    this.playerState = (state) => {
        CastToLocalAdapter.CAST.playerState( {state: state});
    };

    this.getCaptionsInfo = () => {
        return CastToLocalAdapter.CAST.getCaptionsInfo();
    };

    this.setCaptions = ( isPersistent, language ) => {
        CastToLocalAdapter.CAST.setCaptions( { persistent :isPersistent, language: language } );
    };

    this.mediaTracks = ( tracks, activeTrackIds ) => {
        CastToLocalAdapter.CAST.mediaTracks( { mediaTracks: tracks, activeTrackIds: activeTrackIds } )
    }

    this.getAudioTrackInfo = () =>{
        return CastToLocalAdapter.CAST.getAudioTrackInfo();
    }

    this.setAudioTrack = ( track ) => {
        CastToLocalAdapter.CAST.setAudioTrack( { track } );
    }

    this.metadata = ( metadata ) => {
        CastToLocalAdapter.CAST.metadata( metadata )
    }

    this.getSoundSettings = () => {
        return CastToLocalAdapter.CAST.getSoundSettings();
    }

    this.mute = () => {
        CastToLocalAdapter.CAST.mute();
    }

    this.unmute = () => {
        CastToLocalAdapter.CAST.unmute();
    }

    this.volumeUpdate = ( volume ) => {
        CastToLocalAdapter.CAST.volumeUpdate ({volume: volume } );
    };

    this.error = ( message ) => {
        return onCastUIReady(function () {
            CastToLocalAdapter.CAST.sessionError( message );
        });
    }

    this.setStreamType = (streamType) => CastToLocalAdapter.CAST.setStreamType({ streamType });
};
